import { LogoutOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import styled from "styled-components";

export const TextLogo = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  padding: 15px;
`;

export const BrandRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 12px 12px 18px;
`;

export const SiderLogo = styled.img`
  display: block;
  height: 34px;
  width: auto;
  margin: 0;
  padding: 0;
`;

export const ImageLogo = styled.img`
  margin: 0;
  width: 90%;
  padding: 18px;
`;

export const DashboardIcon = styled.span`
  cursor: pointer;
  padding: 10px;
  margin-right: 25px;
`;

export const StyledBtnDiv = styled.div`
  height: 100%;
  margin-bottom: 12px;
`;

export const StyledLogoutIcon = styled(LogoutOutlined)`
  color: red;
  padding-top: 22px;
`;

export const AppLayout = styled(Layout)`
  width: 100%;
  height: 100%;
`;

export const AppContent = styled(Content)`
  width: 100%;
  height: 100%;
`;

export const InputContainer = styled.div`
  padding: 15px;
`;

export const StyledToggle = styled.span`
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #8c8c8c;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  &:hover {
    background: #fff2e9;
    color: #fe6a00;
  }
`;
